module.exports = __webpack_public_path__ + "media/images/logos/instagram-light-fdfbad48b221b4e4f23094613127b2f8.svg";